module.exports = __webpack_public_path__ + "static/img/萌唐唐.0f0cb7a7.png";